import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var TextHelper =
/*#__PURE__*/
function () {
  function TextHelper() {
    _classCallCheck(this, TextHelper);
  }

  _createClass(TextHelper, [{
    key: "getPropertyNameRegex",
    value: function getPropertyNameRegex() {
      return /[+;,\/\&\(\)\?\-\=\'\"\\\xa7\!\%\:\_\s.]+(.)?/g;
    }
  }, {
    key: "removeZeroWidthCharacters",
    value: function removeZeroWidthCharacters(str) {
      return str.replace(/[\u200B-\u200D\uFEFF]/g, '');
    }
  }, {
    key: "addUnderscoreWhenStarsWithNumber",
    value: function addUnderscoreWhenStarsWithNumber(str) {
      if (this.startsWithNumber(str)) {
        return "_".concat(str);
      }

      return str;
    }
  }, {
    key: "startsWithNumber",
    value: function startsWithNumber(str) {
      if (str.match(/^\d/)) {
        return true;
      }

      return false;
    }
  }]);

  return TextHelper;
}();
export var textHelper = new TextHelper();